import React, { useState } from 'react'

export default function Collapsible({ initOpen, containerClass, headerClass, contentClass, header, children, noWrapper, ...props }) {
  const [isOpen, setOpen] = useState(initOpen)

  if (containerClass) {
    return <div className={containerClass}>
      <div className={`schema-form__collapsible-header ${isOpen ? 'open' : 'closed'}-collapsible ${headerClass ?? ''}`} onClick={() => setOpen(!isOpen)}>{header}</div>
      {noWrapper
        ? children(`schema-form__collapsible-content ${isOpen ? 'open' : 'closed'}-collapsible ${contentClass ?? ''}`)
        : <div className={`schema-form__collapsible-content ${isOpen ? 'open' : 'closed'}-collapsible ${contentClass ?? ''}`}>
          {children}
        </div>
      }
    </div>
  } else {
    return (
      <>
        <div className={`schema-form__collapsible-header ${isOpen ? 'open' : 'closed'}-collapsible ${headerClass ?? ''}`} onClick={() => setOpen(!isOpen)}>{header}</div>
        {noWrapper
          ? children(`schema-form__collapsible-content ${isOpen ? 'open' : 'closed'}-collapsible ${contentClass ?? ''}`)
          : <div className={`schema-form__collapsible-content ${isOpen ? 'open' : 'closed'}-collapsible ${contentClass ?? ''}`}>
            {children}
          </div>
        }
      </>
    )
  }
}
